import Zoe from "../../assets/images/zoe2.jpg";

const HeaderPreview = () => {
  return (
    <article className="header">
      <div className="header-portrait">
        <img src={Zoe} alt="Portrait of Zoe-Alanah Robert" width="112" height="112" />
      </div>
      <h2 className="header-font darkgray-text">
        👋 Hi, I'm Zoe.
      </h2>
      <p className="gray-text">I'm a Boston-based software engineer, creative technologist, and privacy advocate. I build transparency tools as a Principal Software Engineer at the <a href="https://asml.cyber.harvard.edu/" target="_blank" rel="noopener noreferrer">Applied Social Media Lab</a> at Harvard University's Berkman Klein Center for Internet &amp; Society, and contribute as a freelance developer to the <a href="https://freedom.press/" target="_blank" rel="noopener noreferrer">Freedom of the Press Foundation</a>. Before that, I studied computer science and artificial intelligence at Stanford and worked at Google, Yelp, Meta, and <a href="https://column.us/" target="_blank" rel="noopener noreferrer">Column</a>.</p>
      <p className="gray-text">My work explores how the collection, movement, and governance of data shape our digital rights. I build technology that protects consumer privacy, preserves news media, and advances platform transparency. As an artist, I use creative technology to make the social impact of digital systems visible to the public, work rooted in my M.A. in Interactive Media Arts from NYU Tisch.</p>

    </article>
  );
};

export default HeaderPreview;
